import { RouteComponentProps } from 'react-router';
import { Desktop, Mobile } from '../../App';
import { Button } from '../../components';
import { CheckText } from '../../components/common/CheckText';
import { getUserFromLS } from '../../helpers/localstorage-helper';
import {
  SETTINGS_VIRTUAL_OFFICE,
  TERMS_AND_CONDITIONS_MIGRATED_CHECK
} from '../../routes/routes';
import { H4 } from '../../styles/FontStyles';
import { Flexed } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import { TravelutionWelcomeLogo } from '../../styles/svg';
import axios from 'axios';

export const IntroWelcome = ({ history }: RouteComponentProps) => {
  const firstLogin = async () => {
    try {
      const user = getUserFromLS();

      if (!user.isFirstLoginPopupChecked) {
        await axios.put(`/user/set-first-login-popup-checked`);
        history.push(SETTINGS_VIRTUAL_OFFICE);
      } else if (!user.isMavieMigrationModalChecked) {
        history.push(TERMS_AND_CONDITIONS_MIGRATED_CHECK);
      }
    } catch (error: any) {
      console.log(error.response);
    }
  };
  return (
    <div>
      <Flexed center justifyCenter>
        <Desktop>
          <TravelutionWelcomeLogo width={200} height={200} />
        </Desktop>
        <Mobile>
          <TravelutionWelcomeLogo width={150} height={150} />
        </Mobile>
      </Flexed>
      <H4 center mb='40'>
        What's new
      </H4>
      <CheckText
        textColor={colors.neutral900}
        text='Credit Card payment now avaliable!'
      />
      <CheckText
        textColor={colors.neutral900}
        text='Commissions payout in your currency to your bank account, '
      />
      <CheckText
        textColor={colors.neutral900}
        text='Compliant with MiCA, GDPR, EU Directives and beyond!'
      />

      <Button mt='40' onClick={firstLogin}>
        Continue
      </Button>
    </div>
  );
};
